<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    data(){
      return {
        items: ["o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", "o", ],
        countUnreadInbox:0
      }
    },
    computed: {
			...mapGetters('auth', ['authenticationSuccess','loggedIn', 'maintenanceMode']),
			...mapGetters('customer', ['customerAlias']),
			...mapGetters('misc', ['linkMarketing', 'guestBgMode']),
      ...mapGetters('registration', ['isAxsr']),
		},
    methods: {
      ...mapActions('auth', ['logout']),
      navigate(path, linkType){
        //linkType - 0: open in same tab || open in new tab -> 1: external, 2: marketing
        if(path != '#'){
          if(linkType == 1){
            window.open(path)
          } else if (linkType == 2) {
            window.open(this.linkMarketing+path)
          } else {
            this.$f7.views.main.router.navigate(path)
          }
        }
      },
      doLogout() {
        console.log("Logging out.....");
        console.log("AXS ? "+this.isAxsr);
        this.logout();
        if(!this.authenticationSuccess && !this.loggedIn){
          if(this.isAxsr){
            this.$f7.views.main.router.navigate("/axsr-login", { force: true, clearPreviousHistory: true, transition: 'f7-fade' })
          }else{
            this.$f7.views.main.router.navigate("/login", { force: true, clearPreviousHistory: true, transition: 'f7-fade' })
            // location.reload()
          }
        }
      },
      checkNotification(){
        const self = this
        const customerInboxMessagesPromise  = self.$api.customer.getInboxMessage(0, 0, 0);
        customerInboxMessagesPromise.then(function(mInbox) {
          self.countUnreadInbox = mInbox.length;
        });
      }

    }
  }
</script>

<template>
  <div :class="this.loggedIn ? 'flow-group-customer' : 'flow-group-guest row no-gap'">
    <div class="col-33 view-desktop" v-show="!this.loggedIn">
      <div class="display-flex justify-content-center align-items-center" style="height: 100%">
        <img :src="require('@/assets/img/wandr-e-logo-big.svg')" />
      </div>
      <!-- <div class="feature-highlight">
        <img :src="require('@/assets/feature_highlight-fx_calc.svg')" />
        <f7-block class="text-center">
          <h1>Make Transactions Easier and Saftier</h1>
          <p>At Wandr, we don’t just send money. We connecting you with your loved ones and the worlday together with.</p>
        </f7-block>
      </div> -->
    </div>
    <div :class="{'col-66': !this.loggedIn}">
      <div v-if="this.maintenanceMode ? false : this.loggedIn ? true : false" class="view-desktop navbar-desktop elevation-5 color-theme-white">
        <f7-navbar>
          <f7-link slot="left" href="/home">
            <img :src="require('@/assets/img/logo-wandr_e.svg')" style="height: 16px;" />
          </f7-link>
          <f7-nav-right>
            <f7-link slot="right" class="px-2 font-no-decoration fw-medium color-theme-black ms-4" @click="navigate('/sendmoney/select-beneficiary')">{{$t('general-text-send')}}</f7-link>
            <f7-link slot="right" class="px-2 font-no-decoration fw-medium color-theme-black" @click="navigate('/transaction-history')">{{$t('general-text-activities')}}</f7-link>
            <f7-link slot="right" class="px-2 font-no-decoration fw-medium color-theme-black" @click="navigate('/beneficiary-list')">{{$t('general-text-recipients')}}</f7-link>
            <f7-link slot="right" class="px-2 font-no-decoration fw-medium color-theme-black" @click="navigate('/account/help-and-support')">{{$t('general-text-help')}}</f7-link>
            <f7-menu>
              <f7-menu-item :text="(this.customerAlias.toLowerCase() == 'customer' || this.customerAlias.trim() == '' ? $t('general-text-account') : this.customerAlias)" dropdown class="no-hairline" @click="checkNotification()">
              <f7-menu-dropdown right>
                <div class="menu-triangle"></div>
                <f7-menu-dropdown-item href="/account" :text="$t('general-text-my-details')"></f7-menu-dropdown-item>
                <f7-menu-dropdown-item divider></f7-menu-dropdown-item>
                <f7-menu-dropdown-item href="/account/invite-earn" :text="$t('general-text-invite-earn')"></f7-menu-dropdown-item>
                <f7-menu-dropdown-item divider></f7-menu-dropdown-item>
                <f7-menu-dropdown-item href="/account/fx-alert" :text="$t('general-text-fx-alert')"></f7-menu-dropdown-item>
                <f7-menu-dropdown-item divider></f7-menu-dropdown-item>
                <f7-menu-dropdown-item href="/account/my-coupon" :text="$t('general-text-coupons')"></f7-menu-dropdown-item>
                <f7-menu-dropdown-item divider></f7-menu-dropdown-item>
                <f7-menu-dropdown-item href="/notification" :text="$t('general-text-notification')"><span v-if="countUnreadInbox > 0" class="badge-notif-number">{{countUnreadInbox }}</span></f7-menu-dropdown-item>
                <f7-menu-dropdown-item divider></f7-menu-dropdown-item>
                <f7-menu-dropdown-item href="#" @click="doLogout()" :text="$t('general-text-logout')" class="text-color-red pointer"></f7-menu-dropdown-item>
              </f7-menu-dropdown>
            </f7-menu-item>
            </f7-menu>
          </f7-nav-right>
        </f7-navbar>
      </div>
      <slot />
      <f7-toolbar v-if="this.loggedIn" class="w-100 p-3 view-desktop" position="bottom" id="page-footer">
        <div class="w-100">
          <div class="d-lg-flex justify-content-between text-center" style="align-items: center;">
            <div>
              <a href="https://www.facebook.com/profile.php?id=100087867352907" class="external py-3 me-3" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-facebook@2x.png')" width="40" height="40"/></div></a>
              <a href="https://www.instagram.com/wandre_sg" class="external py-3 me-3" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-instagram@2x.png')" width="40" height="40"/></div></a>
              <a href="https://twitter.com/wandr_e_" class="external py-3 me-3" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-twitter@2x.png')" width="40" height="40"/></div></a>
              <a href="https://www.linkedin.com/company/wandr-e/about/" class="external py-3" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-linkedin@2x.png')" width="40" height="40"/></div></a>
            </div>
            <div class="d-flex justify-content-center text-center">
              <a href="#" class="py-3 mx-3" @click="navigate('aboutus', 2)">{{$t('general-text-about-us')}}</a>
              <a href="#" class="py-3 mx-3" @click="navigate('press/wandr-e-revolutionising-the-global-fund-transfer-market-with-zero-fees-and-competitive-exchange-rates', 2)">{{$t('general-text-press')}}</a>
              <a href="#" class="py-3 mx-3" @click="navigate('unsubscribe', 2)">{{$t('general-text-unsubscribe')}}</a>
            </div>
          </div>
          <hr />
          <div class="py-3 w-100" style="display: flex; align-items: center; justify-content: space-between;">
            <div>{{$t('general-text-trading-name')}}</div>
            <div class="d-flex-center">
              <div class="fw-bold me-2">{{$t('general-text-pay-together-with')}}</div>
              <img :src="require('@/assets/img/logo-wandr_e-white.svg')" style="height: 16px; margin-top: -6px;" /></div>
          </div>
        </div>
      </f7-toolbar>
    </div>
    <div :class="this.guestBgMode ? 'guest-bg-light' : 'guest-bg-dark'" class="area">
      <ul class="circles">
        <li v-for="(item, key) in this.items" :key="key"></li>
      </ul>
    </div >
  </div>
</template>